module.exports = ".modal-dialog {\n  width: 100%; }\n\n.modal-body {\n  overflow: visible; }\n"